import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _CalculatorOption;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import t from '@instructure/quiz-i18n/es/format-message';
import { View } from '@instructure/ui-view';
import { RadioInputGroup, RadioInput } from '@instructure/ui-radio-input';
import { Checkbox } from '@instructure/ui-checkbox';
import { ScreenReaderContent } from '@instructure/ui-a11y-content';
import testable from '@instructure/ui-testable';
var CalculatorOption = (_dec = testable(), _dec(_class = (_CalculatorOption = /*#__PURE__*/function (_Component) {
  function CalculatorOption() {
    var _this;
    _classCallCheck(this, CalculatorOption);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, CalculatorOption, [].concat(args));
    _defineProperty(_this, "handleCheckboxChange", function (event) {
      var value = event.target.checked ? 'basic' : 'none';
      _this.props.onChange(event, value);
    });
    return _this;
  }
  _inherits(CalculatorOption, _Component);
  return _createClass(CalculatorOption, [{
    key: "isChecked",
    value: function isChecked(value) {
      return ['basic', 'scientific'].includes(value);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        disabled = _this$props.disabled,
        onChange = _this$props.onChange,
        value = _this$props.value;
      var checked = this.isChecked(value);
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Checkbox, {
        disabled: disabled,
        label: t('Show on-screen calculator'),
        onChange: this.handleCheckboxChange,
        value: "none",
        checked: checked,
        "data-automation": "sdk-show-on-screen-calculator-checkbox"
      }), checked && /*#__PURE__*/React.createElement(View, {
        as: "div",
        margin: "small 0 0 medium"
      }, /*#__PURE__*/React.createElement(RadioInputGroup, {
        disabled: disabled,
        name: "calculator",
        onChange: onChange,
        value: value,
        description: /*#__PURE__*/React.createElement(ScreenReaderContent, null, t('Calculator type'))
      }, /*#__PURE__*/React.createElement(RadioInput, {
        label: t('Basic calculator'),
        value: "basic",
        "data-automation": "sdk-basic-calculator-radio-input"
      }), /*#__PURE__*/React.createElement(RadioInput, {
        label: t('Scientific calculator'),
        value: "scientific",
        "data-automation": "sdk-scientific-calculator-radio-input"
      }))));
    }
  }]);
}(Component), _defineProperty(_CalculatorOption, "propTypes", {
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOf(['none', 'basic', 'scientific']).isRequired
}), _defineProperty(_CalculatorOption, "defaultProps", {
  disabled: false
}), _CalculatorOption)) || _class);
export { CalculatorOption as default };